<div class="table-container">
    <!-- Input Field for Adding a User -->
    <div class="add-user-container">
        <app-text-input
            [placeholder]="'Email Address'"
            [(value)]="newUserEmail"
            [hasError]="hasEmailError"
            [helperText]="emailErrorMessage"
            [width]="'361px'"
            (valueChange)="onEmailInput($event)"
        ></app-text-input>
        <app-button label="Add" buttonClass="primary" (clicked)="addUser()"></app-button>
    </div>

    <!-- Table -->
    <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1">
        <!-- User Column -->
        <ng-container matColumnDef="user">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [ngClass]="{ 'sorted-header': sortedColumn === 'user' }"
            >
                User
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div class="user-info">
                    <div class="user-name">{{ element.name }}</div>
                    <div class="user-email">{{ element.email }}</div>
                    <div class="user-role">{{ element.role }}</div>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Added By Column -->
        <ng-container matColumnDef="addedBy">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [ngClass]="{ 'sorted-header': sortedColumn === 'addedBy' }"
            >
                Added By
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.addedBy }}</mat-cell>
        </ng-container>

        <!-- Time Added Column -->
        <ng-container matColumnDef="timeAdded">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [ngClass]="{ 'sorted-header': sortedColumn === 'timeAdded' }"
            >
                Time Added
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.timeAdded | date: "MMM dd, yyyy 'at' hh:mm a" }}</mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-button [showIcon]="true" icon="delete" [showLabel]="false" buttonClass="tertiary" (clicked)="deleteUser(element)" />
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
</div>
